export default "__VITE_ASSET__d46eb52a__"